import React from "react";
import styled from "styled-components";
import { useCardElement } from "../../hooks/index";
import Dropdown from "react-bootstrap/Dropdown"; // Certificando o uso correto do Dropdown

const Header = styled.div`
  position: relative;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderInner = styled.div`
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const DropdownWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 15px;
`;

export default (props) => {
  const ref = React.useRef(null);
  const [Child, setChild] = React.useState(<React.Fragment />);
  const setCardTitle = useCardElement();

  React.useEffect(() => {
    const cardTitle = setCardTitle(props.title);
    if (cardTitle) {
      setChild(
        <HeaderInner>
          <span>{cardTitle}</span>
          <DropdownWrapper>
            <Dropdown>
              <Dropdown.Toggle as="div" id="dropdown-custom-components" style={{ cursor: "pointer" }}>
                <i className="fas fa-ellipsis-v" />
              </Dropdown.Toggle>
              <Dropdown.Menu>

                <Dropdown.Item
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.onEdit) props.onEdit();
                  }}
                >
                  <i className="fas fa-edit text-primary" /> Editar Filial
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.onCertificate) props.onCertificate();
                  }}
                >
                  <i className="fas fa-id-card" /> Certificado Digital
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.onView) props.onView();
                  }}
                >
                  <i className="fas fa-receipt" /> Visualizar Assinatura
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.isActive === false) {
                      if (props.onReactivate) props.onReactivate();
                    } else {
                      if (props.onDelete) props.onDelete();
                    }
                  }}
                >
                  {props.isActive === false ? (
                    <React.Fragment><i className="fas fa-check text-success" /> Reativar Filial</React.Fragment>
                  ) : (
                    <React.Fragment><i className="fas fa-trash text-danger" /> Desativar Filial</React.Fragment>
                  )}
                </Dropdown.Item>

              </Dropdown.Menu>
            </Dropdown>
          </DropdownWrapper>
        </HeaderInner>
      );
    }
  }, [ref.current]);

  return <Header ref={ref}>{Child}</Header>;
};



// WEBPACK FOOTER //
// ./src/_components/Card/components/Header/index.jsx